import { Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import React from 'react'
import Appbar from './Appbar';
import Sidebar from './Sidebar';
import { useNavigate } from 'react-router-dom';
import "../Assets/CSS/BnbConnect.css"

const BuyReport = () => {
    const [mobileOpen, setMobileOpen] = React.useState(false);
    const navigate = useNavigate();
    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };
    return (
        <div className='bnbcontainer'>
            <Grid container>
                <Grid item xs={12} md={12}>
                    <Appbar handleDrawerToggle={handleDrawerToggle} />
                </Grid>

                <Grid item xs={12} md={12}>
                    <Grid container spacing={2}>
                        <Grid item md={2}>
                            <Sidebar open={mobileOpen} handleDrawerToggle={handleDrawerToggle} />
                        </Grid>
                        <Grid item xs={12} md={10} sx={{ mt: "70px" }}>
                            <Grid container spacing={3} p={3}>
                                <Grid item xs={12} md={12}>
                                    <Paper elevation={3} sx={{ backgroundColor: "#232529", color: "white", padding: "15px", borderRadius: "10px" }}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={12}>
                                                <div className='headerconn'>
                                                    <div className='dashbheading'
                                                        onClick={() => {
                                                            navigate("/dashboard")
                                                        }}
                                                    >Dashboard</div>
                                                    <div className='subheading'>
                                                        / Buy Report
                                                    </div>
                                                </div>
                                            </Grid>
                                        </Grid>

                                    </Paper>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Paper elevation={3} sx={{ backgroundColor: "#232529", color: "white", borderRadius: "20px" }}>
                                        <Grid container spacing={1}>
                                            <Grid item xs={12} md={12} >
                                                <div className='topuptitle'>Buy Report</div>
                                            </Grid>
                                            <Grid item xs={12} md={12}>
                                                <hr />
                                            </Grid>
                                            <Grid item xs={12} md={12}>
                                                <Grid container spacing={2} sx={{ paddingLeft: "30px", paddingRight: "30px", paddingBottom: "30px", paddingTop: "10PX" }}>
                                                    <Grid item xs={12} md={12} >
                                                        <TableContainer>
                                                            <Table aria-label="simple table">
                                                                <TableHead>
                                                                    <TableRow >
                                                                        <TableCell sx={{ color: "white", py: 1, textAlign: "center" }}>Sr.No</TableCell>
                                                                        <TableCell sx={{ color: "white", py: 1, textAlign: "center" }}>Wallet Address</TableCell>
                                                                        <TableCell sx={{ color: "white", py: 1, textAlign: "center" }}>Deposit</TableCell>
                                                                        <TableCell sx={{ color: "white", py: 1, textAlign: "center" }}>BCC Token</TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {/* {rows.map((row) => ( */}
                                                                    <TableRow
                                                                        //   key={row.name}
                                                                        sx={{
                                                                            borderBottom: "1px solid white", '&:last-child td, &:last-child th': { border: 0 }
                                                                        }}
                                                                    >
                                                                        <TableCell sx={{ color: "white", textAlign: "center" }} component="th" scope="row"></TableCell>
                                                                        <TableCell sx={{ color: "white", textAlign: "center" }}></TableCell>
                                                                        <TableCell sx={{ color: "white", textAlign: "center" }}></TableCell>
                                                                        <TableCell sx={{ color: "white", textAlign: "center" }}></TableCell>
                                                                    </TableRow>
                                                                    {/* ))} */}
                                                                </TableBody>
                                                            </Table>
                                                        </TableContainer>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Grid>
                            </Grid>
                        </Grid>

                    </Grid>

                </Grid>
            </Grid>
        </div>
    )
}

export default BuyReport